import $http from '../../../axios-instance';
import Swal from 'sweetalert2'
import moment from 'moment'

//Listar tipos de inventario
export async function listInventoryType({ commit }) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.get('/inventory-types/list');
        commit('dashboard/load', false, { root: true });
        return response.data.data;
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        return [];
    }
}

//Filtrar por id de tipo de inventario
export async function filterInventoryType({ commit }, id) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.get('/inventory-types/' + id);
        commit('dashboard/load', false, { root: true });
        return response.data.data;
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        return [];
    }
}

//Asocial columnas a un tipo de inventario
export async function associateColumns({ commit }, data) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.post('/inventory-types/associate-columns', data);
        commit('dashboard/load', false, { root: true });
        Swal.fire({
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
        })
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        Swal.fire({
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 1500
        })
        return [];
    }
}


//Generar reporte de inventario
export async function generateInventoryReport({ commit }, data) {
    await $http({
        url: `inventory-report`,
        method: "POST",
        responseType: "blob",
        params: data
    }).then((response) => {
        new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", 'RPQ_' + data.company_name + '_' + moment().format('YYYY-MM-DD HH:mm:ss') + '.Xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
    })
        .catch((error) => {
            if (error.message) {
                Swal.fire({
                    icon: 'error',
                    title: error.message,
                    showConfirmButton: false,
                    timer: 1500
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Este tipo de inventario no tiene secciones asociadas',
                    showConfirmButton: false,
                    timer: 1500
                })
            }

        })
}

//Listar columnas de inventario
/* export async function listInventoryColumns({commit}) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.get('/inventory-columns/list');
        commit('dashboard/load', false, { root: true });
        return response.data.data;
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        return [];
    }
} */
